import React, { FC, useState, useEffect, useContext, useRef } from 'react'
import moment from 'moment'
import {
  StackedCarousel,
  StackedCarouselSlideProps,
  ResponsiveContainer,
} from 'react-stacked-center-carousel'
import { isMobile } from 'react-device-detect'

import { getSingleFeed } from '../../../Api/backendApi'

import AppContext from '../../../context/appContext'

import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericButton from '../../../GenericComponents/GenericButton'

import {
  CompareImagesBox,
  CompareImage,
  SideContainer,
  CompareImagesScroll,
} from '../style/ProgressScreenStyle'

import EditProgress from '../../../assets/REDESIGN_Assets/Progress/edit-progress.svg'
import RemoveProgress from '../../../assets/REDESIGN_Assets/Progress/remove-progress.svg'
import CompareProgress from '../../../assets/REDESIGN_Assets/Progress/compare-progress.svg'
import GenericColumn from '../../../GenericComponents/GenericColumn'

import OutlineFront from '../../../assets/REDESIGN_Assets/UserWizzard/woman_front_outline.png'
import OutlineBack from '../../../assets/REDESIGN_Assets/UserWizzard/woman_back_outline.png'
import OutlineSide from '../../../assets/REDESIGN_Assets/UserWizzard/woman_side_outline.png'

interface ComparEntriesInterface {
  clickedFeedData: any
  oldestFeedWithPhotos: any
  feeds: any
  activePhoto: any
}

const ComparEntries: FC<ComparEntriesInterface> = ({
  clickedFeedData,
  oldestFeedWithPhotos,
  feeds,
  activePhoto,
}) => {
  const imagesContainerRef: any = useRef(null)
  const containerContainer: any = useRef(null)

  useEffect(() => {
    scrollOnLoad()
  }, [imagesContainerRef])

  const scrollOnLoad = () => {
    if (imagesContainerRef && imagesContainerRef.current) {
      let elementWidth = imagesContainerRef.current.offsetWidth

      containerContainer.current.scrollTo(
        elementWidth / (isMobile ? 3.25 : 4.2),
        0
      )
    }
  }

  return (
    <GenericMainCard
      width={isMobile ? '95%' : '60%'}
      flexDir={'column'}
      className="standard"
      justify={'flex-start'}
      margin={'5% auto 0 auto'}
    >
      <GenericRow>
        <GenericTextSpan margin={isMobile ? '5% 0' : 'unset'} fSize={'1.8rem'}>
          Twoje postępy
        </GenericTextSpan>
      </GenericRow>

      <GenericRow margin={isMobile ? '1% 0 3% 0' : '3% 0 3% 0'}>
        <GenericTextSpan fSize={isMobile ? '1.2rem' : '1.5rem'}>
          Porównywanie wpisów
        </GenericTextSpan>
      </GenericRow>

      {/* Images row */}
      <GenericRow width={isMobile ? '100%' : '70%'} margin={'5% 0 0 0'}>
        <GenericColumn padding={'10px 5px'} width={'50%'}>
          <GenericRow>
            <GenericIcon
              height={'40vh'}
              width={'100%'}
              backgroundSize={'cover'}
              borderRadius={'19px'}
              src={
                oldestFeedWithPhotos &&
                oldestFeedWithPhotos.photos.filter(
                  (photo: any) => photo.type == activePhoto
                )[0].url
              }
            />
          </GenericRow>

          <GenericRow margin={'15% 0 0 0'}>
            <GenericTextSpan>
              {`${oldestFeedWithPhotos.creation_datetime}`}
            </GenericTextSpan>
          </GenericRow>
          <GenericRow margin={'5% 0 0 0'}>
            <GenericTextSpan
              fWeight={'bold'}
              fSize={isMobile ? '1.6rem' : '1.3rem'}
            >
              {`${oldestFeedWithPhotos.belly_circumference} / ${oldestFeedWithPhotos.hip_circumference} / ${oldestFeedWithPhotos.thigh_circumference} `}
            </GenericTextSpan>
          </GenericRow>
        </GenericColumn>

        <GenericColumn padding={'10px 5px'} width={'50%'}>
          <GenericRow>
            <GenericIcon
              height={'40vh'}
              width={'100%'}
              backgroundSize={'cover'}
              borderRadius={'19px'}
              src={
                clickedFeedData &&
                clickedFeedData.images.filter(
                  (photo: any) => photo.type == activePhoto
                )[0].url
              }
            />
          </GenericRow>
          <GenericRow margin={'15% 0 0 0'}>
            <GenericTextSpan>{`${clickedFeedData.date}`}</GenericTextSpan>
          </GenericRow>
          <GenericRow margin={'5% 0 0 0'}>
            <GenericTextSpan
              fWeight={'bold'}
              fSize={isMobile ? '1.6rem' : '1.3rem'}
            >
              {`${
                feeds[clickedFeedData.dimensionNumber].belly_circumference
              } / ${
                feeds[clickedFeedData.dimensionNumber].hip_circumference
              } / ${
                feeds[clickedFeedData.dimensionNumber].thigh_circumference
              }  `}
            </GenericTextSpan>
          </GenericRow>
        </GenericColumn>
      </GenericRow>

      {/* <GenericRow>
        <GenericTextSpan fSize={isMobile ? '1.4rem' : '2rem'}>
          Twoje postępy
        </GenericTextSpan>
      </GenericRow>
      <GenericRow margin={isMobile ? '1% 0 3% 0' : '3% 0 3% 0'}>
        <GenericTextSpan fSize={isMobile ? '0.85rem' : '1.5rem'}>
          Porównywanie wpisów
        </GenericTextSpan>
      </GenericRow>

      <GenericRow margin={'3% 0 3% 0'}>
        <GenericTextSpan fSize={isMobile ? '1rem' : '1.2rem'}>
          {`${oldestFeedWithPhotos.creation_datetime} / ${clickedFeedData.date}`}
        </GenericTextSpan>
      </GenericRow>

      <CompareImagesBox ref={containerContainer}>
        <CompareImagesScroll ref={imagesContainerRef}>
          <SideContainer>
            <GenericRow>
              <GenericTextSpan
                margin={'2% 0'}
                fSize={isMobile ? '1.1rem' : '1.4rem'}
              >
                Tył
              </GenericTextSpan>
            </GenericRow>
            <GenericRow className="fill-available-height">
              <GenericIcon
                margin={'0 1%'}
                backgroundSize={'cover'}
                src={oldestFeedWithPhotos.photos[2].url}
                width={'46%'}
                height={isMobile ? '36vh' : '40vh'}
                borderRadius={isMobile ? '19px' : '30px'}
              />
              <GenericIcon
                margin={'0 1%'}
                backgroundSize={'cover'}
                src={clickedFeedData.images[2].url}
                width={'46%'}
                height={isMobile ? '36vh' : '40vh'}
                borderRadius={isMobile ? '19px' : '30px'}
              />
            </GenericRow>
          </SideContainer>

          <SideContainer>
            <GenericRow>
              <GenericTextSpan
                margin={'2% 0'}
                fSize={isMobile ? '1.1rem' : '1.4rem'}
              >
                Przód
              </GenericTextSpan>
            </GenericRow>

            <GenericRow className="fill-available-height">
              <GenericIcon
                margin={'0 1%'}
                backgroundSize={'cover'}
                src={oldestFeedWithPhotos.photos[0].url}
                width={'46%'}
                height={isMobile ? '36vh' : '40vh'}
                borderRadius={isMobile ? '19px' : '30px'}
              />
              <GenericIcon
                margin={'0 1%'}
                backgroundSize={'cover'}
                src={clickedFeedData.images[0].url}
                width={'46%'}
                height={isMobile ? '36vh' : '40vh'}
                borderRadius={isMobile ? '19px' : '30px'}
              />
            </GenericRow>
          </SideContainer>

          <SideContainer>
            <GenericRow>
              <GenericTextSpan
                margin={'2% 0'}
                fSize={isMobile ? '1.1rem' : '1.4rem'}
              >
                Bok
              </GenericTextSpan>
            </GenericRow>
            <GenericRow className="fill-available-height">
              <GenericIcon
                margin={'0 1%'}
                backgroundSize={'cover'}
                src={oldestFeedWithPhotos.photos[2].url}
                width={'46%'}
                height={isMobile ? '36vh' : '40vh'}
                borderRadius={isMobile ? '19px' : '30px'}
              />
              <GenericIcon
                margin={'0 1%'}
                backgroundSize={'cover'}
                src={clickedFeedData.images[2].url}
                width={'46%'}
                height={isMobile ? '36vh' : '40vh'}
                borderRadius={isMobile ? '19px' : '30px'}
              />
            </GenericRow>
          </SideContainer>
        </CompareImagesScroll>
      </CompareImagesBox>
      <GenericRow margin={'3% 0 0 0'}>
        <GenericTextSpan fSize={'1.5rem'} fWeight={'bold'}>{`${
          oldestFeedWithPhotos.belly_circumference
        } / ${oldestFeedWithPhotos.hip_circumference} / ${
          oldestFeedWithPhotos.thigh_circumference
        }   -   ${
          feeds[clickedFeedData.dimensionNumber].belly_circumference
        } / ${feeds[clickedFeedData.dimensionNumber].hip_circumference} / ${
          feeds[clickedFeedData.dimensionNumber].thigh_circumference
        }  `}</GenericTextSpan>
      </GenericRow> */}
    </GenericMainCard>
  )
}

export default ComparEntries
